import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateButtonTooltipHeading({
  listNameIsValid,
  invalidCustomPropertyName,
  customPropertiesInvalid
}) {
  if (!listNameIsValid) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "segmentsLib.listCreationModal.tooltip.headingText.listName"
    });
  }
  if (invalidCustomPropertyName) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "segmentsLib.listCreationModal.tooltip.headingText.customProperties",
      options: {
        propertyName: invalidCustomPropertyName
      }
    });
  }
  if (customPropertiesInvalid) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "segmentsLib.listCreationModal.tooltip.headingText.invalidProperty"
    });
  }
  return null;
}